import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import PrivateRoute from '../PrivateRoute'
import AppShell from '../layout/AppShell'
import NotFoundPage from '../components/NotFoundPage'
import Login from '../components/Login'

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <PrivateRoute path={['/admin', '/panel']} component={AppShell} />
        <Route exact path="/" component={Login} />
        <Route component={NotFoundPage} />
      </Switch>
    </BrowserRouter>
  )
}

export default Router
